import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocation = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3831 3.5774 C18.8607 3.5771 21.0046 4.4024 22.8134 6.0513 C24.6212 7.7005 25.5255 9.8572 25.5261 12.5216 C25.5259 14.3342 24.764 16.3247 23.2404 18.4932 C21.7176 20.6606 19.4307 23.0033 16.3825 25.5208 C13.334 23.003 11.0475 20.6604 9.525 18.4929 C8.0013 16.3245 7.24 14.3335 7.2392 12.5211 C7.2397 9.8575 8.1439 7.7007 9.9521 6.0517 C11.7612 4.4025 13.9043 3.5768 16.3831 3.5774 Z M15.5864 8.0314 A4.572 4.572 0 1 0 17.1743 17.0365 A4.572 4.572 0 1 0 15.5864 8.0314 Z",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3831 3.5774 C18.8607 3.5771 21.0046 4.4024 22.8134 6.0513 C24.6212 7.7005 25.5255 9.8572 25.5261 12.5216 C25.5259 14.3342 24.764 16.3247 23.2404 18.4932 C21.7176 20.6606 19.4307 23.0033 16.3825 25.5208 C13.334 23.003 11.0475 20.6604 9.525 18.4929 C8.0013 16.3245 7.24 14.3335 7.2392 12.5211 C7.2397 9.8575 8.1439 7.7007 9.9521 6.0517 C11.7612 4.4025 13.9043 3.5768 16.3831 3.5774 Z M15.5864 8.0314 A4.572 4.572 0 1 0 17.1743 17.0365 A4.572 4.572 0 1 0 15.5864 8.0314 Z",
				style: { fill: "var(--sticker-bold,#FF687F)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5864 8.0314 A4.572 4.572 0 1 0 17.1743 17.0365 A4.572 4.572 0 1 0 15.5864 8.0314 Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.3831 3.5774 C18.8607 3.5771 21.0046 4.4024 22.8134 6.0513 C24.6212 7.7005 25.5255 9.8572 25.5261 12.5216 C25.5259 14.3342 24.764 16.3247 23.2404 18.4932 C21.7176 20.6606 19.4307 23.0033 16.3825 25.5208 C13.334 23.003 11.0475 20.6604 9.525 18.4929 C8.0013 16.3245 7.24 14.3335 7.2392 12.5211 C7.2397 9.8575 8.1439 7.7007 9.9521 6.0517 C11.7612 4.4025 13.9043 3.5768 16.3831 3.5774 Z M15.5864 8.0314 A4.572 4.572 0 1 0 17.1743 17.0365 A4.572 4.572 0 1 0 15.5864 8.0314 Z",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#AB2B3E)" }
			})
		]
	});
};
export default SvgLocation;
